import { render, staticRenderFns } from "./Onboarding.vue?vue&type=template&id=45f7907b&scoped=true&"
import script from "./Onboarding.vue?vue&type=script&lang=ts&"
export * from "./Onboarding.vue?vue&type=script&lang=ts&"
import style0 from "./Onboarding.vue?vue&type=style&index=0&id=45f7907b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f7907b",
  null
  
)

export default component.exports